import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";

import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.us";

class PhoneNumberInput extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange = (event) => {
    let input = event.target.value;
    this.props.onChange(this.props.name, input);
  };

  render() {
    let { name, placeholder, label, required, disabled, validate, value } =
      this.props;
    name = name.replace(/_/g, " ");
    let fieldLabel = required ? (label += " *") : label;

    return (
      <div className="form-group row">
        <label
          className="control-label"
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
        <Cleave
          formNoValidate
          className="form-control"
          options={{ phone: true, phoneRegionCode: "US" }}
          name={name}
          label={label}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={this.handleChange}
        />
        {validate && value && value.replace(/\s/g, "").length < 10 && (
          <help style={{ color: "red" }}>
            Please enter a valid phone number
          </help>
        )}
      </div>
    );
  }
}

PhoneNumberInput.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  getValue: PropTypes.func,
  required: PropTypes.bool,
  validate: PropTypes.bool,
};
PhoneNumberInput.defaultProps = {
  validate: false,
};
export default PhoneNumberInput;
